import { z } from 'zod'
import dayjs from 'dayjs'
import { isFilled } from 'utils/validate.util'
import { SystemMessages } from 'utils/enums/system-message.enum'

export const HearingFilterSchema = z
  .object({
    type: z.string().nullish(),
    name: z.string().nullish(),
    dateFrom: z.string().nullish(),
    dateTo: z.string().nullish(),
    responsibleFor: z.string().nullish(),
    cnjNumber: z.string().nullish(),
  })
  .superRefine((fields, ctx) => {
    const { dateFrom, dateTo } = fields

    // Valida se as datas são válidas quando preenchidas
    if (isFilled(dateFrom) && !dayjs(dateFrom).isValid()) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Data inválida.',
        path: ['dateFrom'],
      })
    }

    if (isFilled(dateTo) && !dayjs(dateTo).isValid()) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Data inválida.',
        path: ['dateTo'],
      })
    }

    // Valida a relação entre dateFrom e dateTo
    if (isFilled(dateFrom) && !isFilled(dateTo)) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: SystemMessages.MESSAGE_002,
        path: ['dateTo'],
      })
    }

    if (!isFilled(dateFrom) && isFilled(dateTo)) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: SystemMessages.MESSAGE_002,
        path: ['dateFrom'],
      })
    }
  })

export type HearingFilterForm = z.infer<typeof HearingFilterSchema>

export type HearingFilterRequest = HearingFilterForm & {
  pageSize: number
  page: number
  sort?: string
}

export type HearingFilterResponse = {
  idOitiva?: number
  nome?: string
  documento?: string
  dataInclusao?: string
  dataNascimento?: string
  dataExclusao?: string
  nomeResponsavel?: string
  numeroCnj?: string
}
